var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-group"},[_c('h6',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.showActionButton)?_c('button',{staticClass:"action",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("Change")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }